import styled from 'styled-components'
import { Column, Flex } from '../../../../../styles/styledGlobal'

export const EmployContainer = styled(Column)`
justify-content:space-between;
padding: 1rem;
border-radius: 0.25rem;
border: 2px solid var(--c3);
box-shadow: var(--SombraBackground);
width: 23rem;
`

export const EmployeHeader = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    height: 4.5rem;
    font-size: .875rem;
    line-height: .95rem;
    span,small{
        font-weight: 600;
    }

    small{
        font-size: 0.813rem;
    }
`

export const EmployeBody = styled(Flex)`
    margin:.75rem 0rem .5rem 0rem;
    align-items: center;
    justify-content: center;
`

export const PerfilContainer = styled(Column)`
text-align: center;
    img{
        width: 7.688rem;
        height: 2.063rem;
    }
`

export const ColumnNotas = styled(Column)`
    padding-left:.5rem;
    margin-left:.5rem;

    small{
        font-weight: bold;
    }

    small,span{
        color: var(--c7);
    }

    span{
        font-weight: 100;
    }
`
